import React from "react";

import { Link } from "react-router-dom";

import Chrome from "../components/Chrome";
import Layout from "../components/Layout";
import { additionalInformationURL } from "../urls";
import BodyText from "Cobalt/BodyText";
import { LinkButton } from "Cobalt/Button";
import { CardSection } from "Cobalt/Card";
import { H4 } from "Cobalt/Header";
import { Row, Col } from "Common/Grid";
import Icon from "Common/Icon";

const DonePage = () => (
  <Chrome>
    <Layout>
      <CardSection>
        <Link component={LinkButton} size="medium" to={additionalInformationURL} color="link" pl={0} mb={3}>
          <Icon icon="chevron-left" pr={3} />
          Back
        </Link>
        <Row mb={5}>
          <Col>
            <H4>That&rsquo;s All For Now</H4>
            <BodyText mt={4}>
              We will be reaching out to your broker in 1-3 business days to gather benefits information and get your company installed in SimplyInsured.
            </BodyText>
          </Col>
        </Row>
      </CardSection>
    </Layout>
  </Chrome>
);

export default DonePage;
